// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal, Tag } from 'antd'
import { get, map, includes, toNumber, defaultTo, isNil } from 'lodash'

// Ressources
import { actions as tankActions } from 'Resources/TankResource'
import { actions as siteActions } from 'Resources/SiteResource'

// Common components
import { TableLayout, ManageModal } from 'Components'

// Styles
import './TanksScreen.less'

const { confirm } = Modal

class TanksScreen extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    tank: PropTypes.object,
    tanks: PropTypes.array,
    sites: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Structure du tableLayout
    table: PropTypes.object,

    // Structure de la manageModal
    manageModal: PropTypes.object,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    tank: {},
    tanks: [],
    sites: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false,

    // Structure du tableLayout
    table: {
      // Actions groupÃ©es
      actions: {
        global: {
          create: {
            label: 'common.create',
            icon: 'plus'
          }
        },
        selection: {
          // archive: {
          //   buttonType: 'danger'
          // },
          // update: {
          //   buttonType: 'primary'
          // },
          delete: {
            buttonType: 'danger'
          }
        }
      },

      // Gestion de l'internationalisation
      locale: {
        emptyText: 'pages.tanks.table.empty'
      },

      // Gestion de la pagination
      pagination: {
        position: 'both',
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100']
      },

      // Identifiant unique de chaque ligne du tableau
      rowKey: 'id',

      // Colonnes du tableau
      columns: {
        name: {
          title: 'pages.tanks.table.columns.name.title',
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) =>
            defaultTo(get(a, 'name'), '').localeCompare(
              defaultTo(get(b, 'name'), '')
            ),
          defaultSortOrder: 'ascend'
        },
        element: {
          title: 'pages.tanks.table.columns.element.title',
          dataIndex: 'element',
          key: 'element',
          render: element => (
            <Tag
              color={
                isNil(element)
                  ? 'orange'
                  : element === 'WATER'
                  ? 'blue'
                  : 'purple'
              }
            >
              {defaultTo(
                I18n.t(`pages.tanks.table.columns.element.${element}`),
                I18n.t('common.none.male')
              )}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'element'), '').localeCompare(
              defaultTo(get(b, 'element'), '')
            )
        },
        site: {
          title: 'pages.basins.table.columns.site.title',
          dataIndex: 'site',
          key: 'site',
          render: site => (
            <Tag color={isNil(get(site, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(site, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'site.name'), '').localeCompare(
              defaultTo(get(b, 'site.name'), '')
            )
        },
        volume: {
          title: 'pages.tanks.table.columns.volume.title',
          dataIndex: 'volume',
          key: 'volume',
          render: volume =>
            !isNil(volume)
              ? `${defaultTo(volume, 0).toLocaleString()} mÂ³`
              : I18n.t('common.none.male'),
          sorter: (a, b) =>
            defaultTo(get(a, 'volume'), 0) - defaultTo(get(b, 'volume'), 0)
        }
      }
    },

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.tanks.modal.update.single.title',
        create: 'pages.tanks.modal.create.single.title'
      },
      okText: {
        update: 'pages.tanks.modal.update.single.okText',
        create: 'pages.tanks.modal.create.single.okText'
      },
      actions: {
        delete: {
          buttonType: 'danger'
        }
      },
      rows: {
        name: {
          title: 'pages.tanks.modal.rows.name.title',
          dataIndex: 'name',
          key: 'name',
          formField: {
            label: 'pages.tanks.modal.rows.name.title',
            required: 'pages.tanks.modal.rows.name.requiredMessage',
            placeholder: 'pages.tanks.modal.rows.name.placeholder'
          }
        },
        site: {
          title: 'pages.basins.modal.rows.site.title',
          dataIndex: 'site',
          key: 'site',
          formField: {
            type: 'searchSelect',
            label: 'pages.basins.modal.rows.site.title',
            required: 'pages.silos.modal.rows.site.requiredMessage',
            placeholder: 'pages.basins.modal.rows.site.placeholder',
            format: site => get(site, 'id')
          }
        },
        element: {
          title: 'pages.tanks.modal.rows.element.title',
          dataIndex: 'element',
          key: 'element',
          formField: {
            type: 'searchSelect',
            label: 'pages.tanks.modal.rows.element.title',
            required: 'pages.tanks.modal.rows.element.requiredMessage',
            placeholder: 'pages.tanks.modal.rows.element.placeholder'
          }
        },
        volume: {
          title: 'pages.tanks.modal.rows.volume.title',
          dataIndex: 'volume',
          key: 'volume',
          formField: {
            label: 'pages.tanks.modal.rows.volume.title',
            required: 'pages.tanks.modal.rows.volume.requiredMessage',
            placeholder: 'pages.tanks.modal.rows.volume.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.tanks.modal.rows.volume.patternMessage'
            },
            addonAfter: 'mÂ³',
            format: volume => (!isNil(volume) ? toNumber(volume) : undefined)
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchTanksData()

    // RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
    this.fetchSitesData()
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchTanksData = () => {
    this.props.actions.fetchTanks().catch(() => {
      message.error(I18n.t('api.errors.tank.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
   */
  fetchSitesData = () => {
    this.props.actions.fetchSites().catch(() => {
      message.error(I18n.t('api.errors.site.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getTankData = tank =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getTank(tank)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.tank.get'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Archivage de plusieurs lignes du tableau
   */
  archiveTanks = (tanks, clearTableSelections) => {
    this.props.actions
      .archiveTanks(tanks)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.tank.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.tank.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveTank = tank => {
    this.props.actions
      .archiveTank(tank)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.tank.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.tank.archive'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Suppression de plusieurs lignes du tableau
   */
  deleteTanks = (tanks, clearTableSelections) => {
    this.props.actions
      .deleteTanks(tanks)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.tank.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.tank.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteTank = tank => {
    this.props.actions
      .deleteTank(tank)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.tank.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.tank.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un tank
   */
  updateTank = (updatedTank, originalTank) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateTank({ id: get(originalTank, 'id'), ...updatedTank })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.tank.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.tank.update'))
        })
    })

  /**
   * CrÃ©ation d'un tank
   */
  createTank = createdTank =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createTank(createdTank)
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.tank.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.tank.create'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveTanks = (...params) => {
    confirm({
      title: I18n.t('pages.tanks.modal.archive.multiple.title'),
      content: I18n.t('pages.tanks.modal.archive.multiple.content'),
      okText: I18n.t('pages.tanks.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.tanks.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveTanks(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveTank = () => {
    const tank = get(this.props, 'tank')

    confirm({
      title: I18n.t('pages.tanks.modal.archive.single.title'),
      content: I18n.t('pages.tanks.modal.archive.single.content'),
      okText: I18n.t('pages.tanks.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.tanks.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveTank(tank)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteTanks = (...params) => {
    confirm({
      title: I18n.t('pages.tanks.modal.delete.multiple.title'),
      content: I18n.t('pages.tanks.modal.delete.multiple.content'),
      okText: I18n.t('pages.tanks.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.tanks.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteTanks(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteTank = () => {
    const tank = get(this.props, 'tank')

    confirm({
      title: I18n.t('pages.tanks.modal.delete.single.title'),
      content: I18n.t('pages.tanks.modal.delete.single.content'),
      okText: I18n.t('pages.tanks.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.tanks.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteTank(tank)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({ openedModal: creating ? 'createTank' : 'updateTank' })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateTank') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(this.setState({ openedModal: null }), 200)
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleTankCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = tank => {
    this.getTankData(tank)
    this.setState({ openedModal: 'updateTank' })
  }

  render() {
    const {
      table,
      isGathering,
      manageModal,
      isUpdating,
      isCreating,
      tanks,
      sites,
      tank
    } = this.props
    const { openedModal } = this.state

    // GESTION DES TABLEAUX

    // Ajout des donnÃ©es au tableau
    table.rows = tanks

    // Ajout des actions au clic sur un ligne du tableau
    table.onRow = (tank, id) => ({
      onClick: () => this.handleRowClick(tank, id)
    })

    // Ajout des actions multiples sur le tableau
    // table.actions.selection.archive.onClick = this.askArchiveTanks
    table.actions.selection.delete.onClick = this.askDeleteTanks
    // table.actions.selection.update.onClick = this.askUpdateTanks

    // GESTION DES BOUTONS

    // Ajout des actions des boutons
    table.actions.global.create.onClick = this.openModal

    // GESTION DE LA MODALE DE GESTION

    // Ajout des actions sur la modale
    manageModal.actions.delete.onClick = this.askDeleteTank

    // Ajout des options pour le choix d'un type
    manageModal.rows.element.formField.options = map(
      ['WATER', 'EMULSIFIER'],
      (element, id) => ({
        id,
        label: `pages.tanks.table.columns.element.${element}`,
        disabled: false,
        value: element
      })
    )

    // Ajout des options pour le choix d'un site
    manageModal.rows.site.formField.options = map(sites, site => ({
      id: get(site, 'id'),
      label: get(site, 'name'),
      disabled: false,
      value: get(site, 'id'),
      data: site
    }))

    // GESTION DES LOADERS
    const loading = isGathering || isUpdating || isCreating

    return (
      <main className='screen tanks'>
        {/* Affichage des donnÃ©es de la page */}
        <TableLayout
          elementName='tank'
          elementKind='male'
          elementConsonant
          loading={loading}
          {...table}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleTankCreated}
          onChange={
            openedModal === 'updateTank' ? this.updateTank : this.createTank
          }
          visible={includes(['createTank', 'updateTank'], openedModal)}
          data={
            includes(['transition', 'updateTank'], openedModal) ? tank : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(TanksScreen, 'defaultProps', {})

  return {
    tank: defaultTo(get(state, 'tank.item'), defaultProps.tank),
    tanks: defaultTo(get(state, 'tank.items'), defaultProps.tanks),
    sites: defaultTo(get(state, 'site.items'), defaultProps.sites),
    isGathering:
      defaultTo(get(state, 'tank.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'site.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'tank.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'tank.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...tankActions, ...siteActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TanksScreen)
